/**
 * Header Component
 * Uses ES modules and CSS modules
 */

import styles from "./Header.module.css";

export class Header {
  constructor() {
    this.navItems = [
      { label: "Home", href: "#home" },
      { label: "About", href: "#about" },
      { label: "Programs", href: "#programs" },
      { label: "Schedule", href: "#schedule" },
      { label: "Faculty", href: "#faculty" },
      { label: "Enroll", href: "/join" },
    ];
  }

  render() {
    const header = document.createElement("header");
    header.className = styles.header;
    header.setAttribute("role", "banner");

    const container = document.createElement("div");
    container.className = styles.container;

    // Logo
    const logo = document.createElement("a");
    logo.href = "/";
    logo.className = styles.logo;
    logo.setAttribute("aria-label", "Classical Ballet of California Home");

    const logoImg = document.createElement("img");
    logoImg.src = "./logo.svg";
    logoImg.alt = "Classical Ballet of California";
    logo.appendChild(logoImg);

    // Navigation
    const nav = document.createElement("nav");
    nav.className = styles.nav;
    nav.setAttribute("role", "navigation");
    nav.setAttribute("aria-label", "Main navigation");

    const navList = document.createElement("ul");
    navList.className = styles.navList;

    this.navItems.forEach((item) => {
      const listItem = document.createElement("li");
      const link = document.createElement("a");
      link.href = item.href;
      link.textContent = item.label;
      link.className = styles.navLink;

      // Handle anchor links for smooth scroll
      if (item.href.startsWith("#")) {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          const targetId = item.href.slice(1);
          const target = document.getElementById(targetId);
          if (target) {
            target.scrollIntoView({ behavior: "smooth", block: "start" });
            // Close mobile menu if open
            const nav = link.closest(`.${styles.nav}`);
            if (nav && nav.classList.contains(styles.navOpen)) {
              nav.classList.remove(styles.navOpen);
              const menuButton = document.querySelector(
                `.${styles.menuButton}`,
              );
              if (menuButton) {
                menuButton.setAttribute("aria-expanded", "false");
              }
            }
          }
        });
      }

      // Mark current page
      if (
        window.location.pathname === item.href ||
        (item.href.startsWith("#") && window.location.hash === item.href)
      ) {
        link.setAttribute("aria-current", "page");
        link.classList.add(styles.active);
      }

      listItem.appendChild(link);
      navList.appendChild(listItem);
    });

    nav.appendChild(navList);

    // Mobile menu button
    const menuButton = document.createElement("button");
    menuButton.className = styles.menuButton;
    menuButton.setAttribute("aria-label", "Toggle menu");
    menuButton.setAttribute("aria-expanded", "false");
    menuButton.innerHTML = "<span></span><span></span><span></span>";

    menuButton.addEventListener("click", () => {
      const isExpanded = menuButton.getAttribute("aria-expanded") === "true";
      menuButton.setAttribute("aria-expanded", !isExpanded);
      nav.classList.toggle(styles.navOpen);
    });

    container.appendChild(logo);
    container.appendChild(menuButton);
    container.appendChild(nav);
    header.appendChild(container);

    return header;
  }
}
